// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"xbCNqpHvdhlmcMTi8Cj3"};